module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-700-latin8.db81921.woff2";